// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mstx","icon":"styles_icon__3iiYe"};